export const TOUR_IDS = {
  SHELL_DESKTOP: 'shell-desktop-v1',
  SHELL_MOBILE: 'shell-mobile-v1',
  DEMO_BOOTSTRAP: 'demo-bootstrap-v1',
};

export const tourDefinitions = {
  [TOUR_IDS.SHELL_DESKTOP]: {
    steps: [
      {
        id: 'nav-menu',
        target: '[data-tour="nav-menu"]',
        titleKey: 'tour.shell.nav.title',
        bodyKey: 'tour.shell.nav.body',
        placement: 'right',
        when: (ctx) => !ctx.isMobile,
      },
      {
        id: 'administration-nav',
        target: '[data-tour="administration-nav"]',
        titleKey: 'tour.shell.administration.title',
        bodyKey: 'tour.shell.administration.body',
        placement: 'right',
        when: (ctx) => !ctx.isMobile,
        skipIfMissing: true,
      },
      {
        id: 'project-selector',
        target: '[data-tour="project-selector"]',
        titleKey: 'tour.shell.project.title',
        bodyKey: 'tour.shell.project.body',
        placement: 'right',
        when: (ctx) => !ctx.isMobile,
        skipIfMissing: true,
      },
      {
        id: 'sidebar-controls',
        target: '[data-tour="sidebar-controls"]',
        titleKey: 'tour.shell.sidebarControls.title',
        bodyKey: 'tour.shell.sidebarControls.body',
        placement: 'right',
        when: (ctx) => !ctx.isMobile,
      },
      {
        id: 'main-content',
        target: '[data-tour="main-content"]',
        titleKey: 'tour.shell.main.title',
        bodyKey: 'tour.shell.main.body',
        placement: 'left',
        when: (ctx) => !ctx.isMobile,
      },
      {
        id: 'app-footer',
        target: '[data-tour="app-footer"]',
        titleKey: 'tour.shell.footer.title',
        bodyKey: 'tour.shell.footer.body',
        placement: 'top',
        when: (ctx) => !ctx.isMobile && ctx.showAppFooter,
        skipIfMissing: true,
      },
      {
        id: 'user-profile',
        target: '[data-tour="user-profile"]',
        titleKey: 'tour.shell.profile.title',
        bodyKey: 'tour.shell.profile.body',
        placement: 'right',
        when: (ctx) => !ctx.isMobile,
      },
    ],
  },

  [TOUR_IDS.SHELL_MOBILE]: {
    steps: [
      {
        id: 'mobile-nav-toggle',
        target: '[data-tour="mobile-nav-toggle"]',
        titleKey: 'tour.shell.mobileNav.title',
        bodyKey: 'tour.shell.mobileNav.body',
        placement: 'bottom',
        when: (ctx) => ctx.isMobile && !ctx.isOnAppHome,
      },
      {
        id: 'mobile-project-pill',
        target: '[data-tour="mobile-project-pill"]',
        titleKey: 'tour.shell.mobileProject.title',
        bodyKey: 'tour.shell.mobileProject.body',
        placement: 'bottom',
        when: (ctx) => ctx.isMobile && !ctx.isOnAppHome,
        skipIfMissing: true,
      },
      {
        id: 'mobile-metro',
        target: '[data-tour="mobile-metro"]',
        titleKey: 'tour.shell.mobileMetro.title',
        bodyKey: 'tour.shell.mobileMetro.body',
        placement: 'bottom',
        when: (ctx) => ctx.isMobile,
      },
      {
        id: 'app-footer',
        target: '[data-tour="app-footer"]',
        titleKey: 'tour.shell.footerMobile.title',
        bodyKey: 'tour.shell.footerMobile.body',
        placement: 'top',
        when: (ctx) => ctx.isMobile && ctx.showAppFooter,
        skipIfMissing: true,
      },
    ],
  },

  [TOUR_IDS.DEMO_BOOTSTRAP]: {
    steps: [
      {
        id: 'nav-menu',
        target: '[data-tour="nav-menu"]',
        titleKey: 'tour.demo.nav.title',
        bodyKey: 'tour.demo.nav.body',
        placement: 'right',
        when: (ctx) => !ctx.isMobile,
      },
      {
        id: 'project-selector',
        target: '[data-tour="project-selector"]',
        titleKey: 'tour.demo.project.title',
        bodyKey: 'tour.demo.project.body',
        placement: 'right',
        when: (ctx) => !ctx.isMobile,
        skipIfMissing: true,
      },
      {
        id: 'main-content',
        target: '[data-tour="main-content"]',
        titleKey: 'tour.demo.main.title',
        bodyKey: 'tour.demo.main.body',
        placement: 'left',
        when: (ctx) => !ctx.isMobile,
      },
    ],
  },
};
